export default class KeyControl {
  constructor(callback) {
    this.n = 0;
    this.s = 0;
    this.e = 0;
    this.w = 0;
    this.fired = 0;
    this.callback = callback;
    this.enabled = false;

  }

  destroy() {
    jQuery(window).off("keydown.key");
    jQuery(window).off("keyup.key");
  }

  init() {
    jQuery(window).on("keydown.key", this.onKeyDown.bind(this));
    jQuery(window).on("keyup.key", this.onKeyUp.bind(this));
  }

  enable(lFlag) {
    this.enabled = lFlag;
  }

  onKeyDown(e) {
    //console.log(e.keyCode)
    if (!this.enabled) {
      e.preventDefault();
      return;
    }
    if ((e.keyCode === KeyControl.UP) || (e.keyCode === KeyControl.UP_ALT)) {
      e.preventDefault();
      this.n = 1;
    }
    if ((e.keyCode === KeyControl.RIGHT) || (e.keyCode === KeyControl.RIGHT_ALT)) {
      e.preventDefault();
      this.e = 1;
    }
    if ((e.keyCode === KeyControl.LEFT) || (e.keyCode === KeyControl.LEFT_ALT)) {
      e.preventDefault();
      this.w = 1
    }
    if ((e.keyCode === KeyControl.DOWN) || (e.keyCode === KeyControl.DOWN_ALT)) {
      e.preventDefault();
      this.s = 1;
    }

    if ((e.keyCode === KeyControl.FIRE) || (e.keyCode === KeyControl.FIRE_ALT)) {
      e.preventDefault();
      this.fired = 1;
    }

    this.callback.call(null, this);
    this.n = 0;
    this.s = 0;
    this.e = 0;
    this.w = 0;
    this.fired = 0;

  }

  onKeyUp(e) {
    this.n = 0;
    this.s = 0;
    this.e = 0;
    this.w = 0;
    this.fired = 0;
    this.callback.call(null, this);
  }



}

KeyControl.UP = 87;
KeyControl.DOWN = 83;
KeyControl.LEFT = 65;
KeyControl.RIGHT = 68;
KeyControl.FIRE = 69;

KeyControl.UP_ALT = 38;
KeyControl.DOWN_ALT = 40;
KeyControl.LEFT_ALT = 37;
KeyControl.RIGHT_ALT = 39;
KeyControl.FIRE_ALT = 32;
